export default __webpack_public_path__ + "static/docs-df0a93af6c0d9c7e62f3143f32d97828.png";